import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import { resetLowStockItems } from '../../../actions/reports/low-stock-items';
import { fetchLowStockItems } from '../../../sagas/reports/low-stock-items/routines';

const initialState = {
  all: [],
  fetching: false,
  fetched: false,
  fetchingError: null
};

const fetchLowStockItemsHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('all', response.items, state),
  [routine.FAILURE]: (state, { error }) => set('fetchingError', error, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const resetLowStockItemsHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchLowStockItemsHandler(fetchLowStockItems),
  ...resetLowStockItemsHandler(resetLowStockItems)
});
